import { FetchError } from '@jucy/rentals-api-client';
import { asError } from './asError';

export const isAbortError = (thrown: unknown) => {
    const error = asError(thrown);
    return error?.message === 'Aborted' || (error as FetchError)?.cause?.message === 'Aborted';
};
